export enum Spacing {
  Tiny = '0.25em',
  Small = '0.5em',
  Medium = '1em',
  Large = '2em',
  XLarge = '4em',
  XXLarge = '8em'
}
